import cloneDeep from 'lodash/cloneDeep';

import { EXPENSE_LANDING_CONST, EXPENSE_DETAILS_CONST } from '../actionConstants';
import {formatLandingData} from '../../UtilityComponents/expenseUtils';
import {toSubmitDropDown, EXPENSE_TYPE, INITIAL_BASE_STATE} from '../../expense/config';

const INITIAL_STATE = {
	expensesToSubmit :{
		expDropDownFilter : cloneDeep(toSubmitDropDown),
		...INITIAL_BASE_STATE,
	},
	submittedExpenses : {
		...INITIAL_BASE_STATE
	},
	expenseSummary : {
		error : false,
		loading : false,
	},
	expenseApproval: {
		...INITIAL_BASE_STATE
	},
	feature: 0,
	modalData: {
		modalToggleState: false,
		modalType: '',
		modalStateData: {}
	}
}

export default (state = INITIAL_STATE, action) => {
	if (!action) {
		return state;
	}

	const { type, payload = {} } = action;
	switch (type) {
		case EXPENSE_LANDING_CONST.EXPENSE_SUMMARY: {
			return {
				...state,
				[EXPENSE_TYPE.EXPENSE_SUMMARY]:{
					error : false,
					loading : false,
					...payload
				}
			}
		}
		case EXPENSE_LANDING_CONST.EXPENSE_DATA: {
			const {responseData, filterQuery, expenseType, isSort, shouldFilter, isFirstCall} = payload;
			const data = state[expenseType] ||  {};
			const {expenseData, expDropDownFilter = {}, defaultFilter={}} = data || {};
			const formattedData = formatLandingData(responseData, expenseData, expenseType, expDropDownFilter, isSort, shouldFilter, defaultFilter, isFirstCall);
			const resp = formattedData ? formattedData : state[expenseType];
			return {
				...state,
				[expenseType] : {...state[expenseType], ...resp, filterQuery},
			}
		}
		case EXPENSE_LANDING_CONST.EXPENSE_ERROR: {
			return{
				...state,
				[payload.expenseType] : {...state[payload.expenseType], error: true, loading : false}
			}
		}
		case EXPENSE_LANDING_CONST.EXPENSE_LOADING: {
			let loading  = true;
			const {expenseType: loadingExpenseType} = payload;
			if(loadingExpenseType === EXPENSE_TYPE.EXPENSES_TO_SUBMIT) {
				const {expenseData = {}} = state[loadingExpenseType];
				const {expenseList = []} = expenseData;
				loading= expenseList.length <= 0;
			}
			
			return{
				...state,
				[payload.expenseType] : {...state[payload.expenseType], loading: loading}
			}
		}
		case EXPENSE_LANDING_CONST.FEATURE_DATA: {
			return{
				...state,
				...payload
			}
		}
		case EXPENSE_LANDING_CONST.EXPENSE_MODAL:{
			return{
				...state,
				...payload
			}
		}
		case EXPENSE_LANDING_CONST.EXPENSE_FILTER:{
			return {
				...state,
				[EXPENSE_TYPE.EXPENSES_TO_SUBMIT]:{
					...state[EXPENSE_TYPE.EXPENSES_TO_SUBMIT],
					defaultFilter: payload
				}
			}
		}
		case EXPENSE_LANDING_CONST.CLEAR_STATE:{
			return {
				...INITIAL_STATE
			}
		}
		default:
			return state;
	}
}
